import { useState, useRef } from "react";
import useClickOutside from "../hooks/useClickOutside";

const CATEGORY_OPTIONS = [
    { value: "FABRIC", label: "Тканини" },
    { value: "HARDWARE", label: "Фурнітура" },
    { value: "THREAD", label: "Нитки" },
    { value: "FILLING", label: "Наповнювач" },
    { value: "SUPPORT", label: "Підкладка / допоміжні" },
    { value: "PACKAGING", label: "Пакування" },
    { value: "PRINTS_EMBROIDERY", label: "Накати та вишивка" },
];

export default function CategoriesInput({ value = [], onChange }) {
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);

    const ref = useRef();

    useClickOutside(ref, () => setOpen(false));

    const selected = CATEGORY_OPTIONS.filter(opt =>
        value.includes(opt.value)
    );

    const filtered = CATEGORY_OPTIONS.filter(opt =>
        opt.label.toLowerCase().includes(query.toLowerCase()) &&
        !value.includes(opt.value)
    );

    const addCategory = (val) => {
        onChange([...value, val]);
        setQuery("");
    };

    const removeCategory = (val) => {
        onChange(value.filter(v => v !== val));
    };

    return (
        <div ref={ref} style={{ position: "relative" }}>

            {/* Теги */}
            <div className="d-flex flex-wrap gap-2 mb-2">
                {selected.map(cat => (
                    <div
                        key={cat.value}
                        style={{
                            background: "#e9ecef",
                            padding: "4px 8px",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                        }}
                    >
                        {cat.label}
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => removeCategory(cat.value)}
                        >
              ❌
            </span>
                    </div>
                ))}
            </div>

            {/* Инпут */}
            <input
                className="form-control"
                placeholder="Вибрати категорії..."
                value={query}
                onFocus={() => setOpen(true)}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && filtered.length) {
                        addCategory(filtered[0].value);
                    }

                    if (e.key === "Backspace" && !query && value.length) {
                        removeCategory(value[value.length - 1]);
                    }
                }}
            />

            {/* Dropdown */}
            {open && filtered.length > 0 && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 10,
                        background: "#fff",
                        border: "1px solid #ddd",
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                        borderRadius: "6px",
                        marginTop: "4px"
                    }}
                >
                    {filtered.map(opt => (
                        <div
                            key={opt.value}
                            style={{
                                padding: "8px",
                                cursor: "pointer"
                            }}
                            onClick={() => addCategory(opt.value)}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}

        </div>
    );
}